import { render, staticRenderFns } from "./MailUnsetPostPackage.vue?vue&type=template&id=11204dad&scoped=true"
import script from "./MailUnsetPostPackage.vue?vue&type=script&lang=js"
export * from "./MailUnsetPostPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11204dad",
  null
  
)

export default component.exports